import { createContext } from 'react'

const SelectCountryContext = createContext()

export default SelectCountryContext
